import {
  readStoredSession,
  isAccessTokenExpired,
  refreshSession,
  extractExpiresAtFromAccessToken,
} from '../api/token-storage';
import { setSession } from '../api/api';

/**
 * Silently ensure the access token is valid before making API calls.
 * If expired, refreshes it WITHOUT dispatching auth:change (emit: false)
 * so the onboarding boot context does NOT reload.
 *
 * Returns true if a valid token is available, false if refresh failed.
 */
export async function ensureValidToken(): Promise<boolean> {
  const session = readStoredSession();

  if (!isAccessTokenExpired(session.expires_at)) {
    return true;
  }

  try {
    const refreshed = await refreshSession();
    if (refreshed?.access_token) {
      const expires_at = extractExpiresAtFromAccessToken(refreshed.access_token) || 0;

      // Update storage + axios header WITHOUT triggering auth:change event
      setSession(refreshed.access_token, refreshed.refresh_token, {
        ...(typeof refreshed.expires_in === 'number' ? { expires_in: refreshed.expires_in } : {}),
        expires_at,
        emit: false, // Critical: do NOT trigger onboarding boot context reload
      });

      return true;
    }
    return false;
  } catch {
    return false;
  }
}
